import { getSandboxUrl } from "./sandboxUrl";
import { retrieveAuthToken } from "../utils";

import { ChoresClient } from "./svcChores";
import { PlaClient } from "./svcPla";
export { PlaClient };
export type { ModifyLessonAssignmentBody, ChoresNotifyPreference } from "./svcChores";

// Export some global types
export { ServiceError } from "@securityjourney/service-client";

// Clients from imported libraries
import { SandboxClient } from "@securityjourney/svc-sandbox";
export type {
  SandboxStatus,
  SandboxCode,
  TestStatus,
  SandboxCredentials,
} from "@securityjourney/svc-sandbox";

import { LessonEventsClient } from "@securityjourney/svc-lesson";
export type {
  LessonEventsClient,
  HintUsageResponse,
  CtfSubmissionResponse,
} from "@securityjourney/svc-lesson";

import { IntegrationsClient } from "./svcIntegrationsClient";
import { ExperimentClient } from "./svcExperimentClient";
export type {
  CWE,
  CWEsResponse,
  CWEFilterOptions,
  IntegrationsClient,
} from "./svcIntegrationsClient";
export type {
  GuardianClient,
  ScannerType,
  ScanStatus,
  ScannersResponse,
  MetricsSummaryResponse,
  ScanMetricsSummary,
  ScanRecord,
  ScanHistoryResponse,
  TokenUsage,
} from "./svcGuardianClient";
export { getGuardianClient } from "./svcGuardianClient";
import { IdpClient, IdpAdminClient, LoginClient } from "./svcIdp";
export type {
  ExamInstance,
  ExamConfiguration,
  ExamFilters,
  ExamQuestion,
  ExamAnswer,
  ExamResult,
  ExamSections,
} from "./svcProctor";
export type {
  PersonalizedLessonAssignment,
  TenantPLAResponse,
  UpdatePLAResponse,
  LessonDetails as PLALessonDetails,
  PLASource,
  LearnerDetails as PLALearnerDetails,
} from "./svcPla";

// Singleton instances of each client

let choreClientInstance: ChoresClient | null = null;
let plaClientInstance: PlaClient | null = null;
let idpClientInstance: IdpClient | null = null;
let sandboxClientInstance: SandboxClient | null = null;
let integrationsClientInstance: IntegrationsClient | null = null;
let lessonEventsClientInstance: LessonEventsClient | null = null;
let experimentClientInstance: ExperimentClient | null = null;
let idpAdminClientInstance: IdpAdminClient | null = null;
let loginClientInstance: LoginClient | null = null;

// Exported functions to get singleton instances of each client
export const getLessonEventsClient = (): LessonEventsClient => {
  if (!lessonEventsClientInstance) {
    lessonEventsClientInstance = new LessonEventsClient(retrieveAuthToken);
  }
  return lessonEventsClientInstance;
};

export const getChoresClient = (): ChoresClient => {
  if (!choreClientInstance) {
    choreClientInstance = new ChoresClient();
  }
  return choreClientInstance;
};

export const getPlaClient = (): PlaClient => {
  if (!plaClientInstance) {
    plaClientInstance = new PlaClient();
  }
  return plaClientInstance;
};

export const getIdpClient = (): IdpClient => {
  if (!idpClientInstance) {
    idpClientInstance = new IdpClient();
  }
  return idpClientInstance;
};

export const getIdpAdminClient = (): IdpAdminClient => {
  if (!idpAdminClientInstance) {
    idpAdminClientInstance = new IdpAdminClient();
  }
  return idpAdminClientInstance;
};

export const getLoginClient = (): LoginClient => {
  if (!loginClientInstance) {
    loginClientInstance = new LoginClient();
  }
  return loginClientInstance;
};

export const getSandboxClient = (): SandboxClient => {
  const sandboxUrl = getSandboxUrl();
  if (!sandboxClientInstance) {
    sandboxClientInstance = new SandboxClient(retrieveAuthToken, sandboxUrl);
  }
  return sandboxClientInstance;
};

export const getIntegrationsClient = (): IntegrationsClient => {
  if (!integrationsClientInstance) {
    integrationsClientInstance = new IntegrationsClient(retrieveAuthToken);
  }
  return integrationsClientInstance;
};

export const getExperimentClient = (): ExperimentClient => {
  if (!experimentClientInstance) {
    experimentClientInstance = new ExperimentClient(retrieveAuthToken);
  }
  return experimentClientInstance;
};
